import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CommonToast from "../../../components/_utils/CommonToast";
import { env } from "../../../env";
import axiosInstance from "../../globalInspector/axiosInstance";
import ICONS from "../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

export const createCustomCategory = createAsyncThunk(
  "createCustomCategory",
  async (values, { rejectWithValue }) => {
    // eslint-disable-next-line no-unused-vars
    const { name, description, configuration, logo_data, asset_properties } =
      values;

    const requestBody = {
      transaction_category: {
        name,
        ...(description ? { description } : {}),
        ...(configuration ? { configuration: { data: configuration } } : {}),
        ...(asset_properties ? { asset_properties: asset_properties } : {}),
        // ...(logo_data && Object.keys(logo_data).length ? { logo_data } : {}), /*commented because, if in case in future there will be requriement*/
      },
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
    };

    try {
      const response = await axiosInstance.post(
        `${baseUrl}/transaction_categories`,
        requestBody,
        config,
      );
      return response.data;
    } catch (error) {
      const errors = error?.response?.data?.errors;

      const errorMessage =
        error?.response?.data?.errors?.configuration?.[0] ||
        error?.response?.data?.errors?.base?.[0];
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      return rejectWithValue({
        status: error?.response?.status,
        message: errorMessage,
        errors,
      });
    }
  },
);

export const editCustomCategory = createAsyncThunk(
  "editCustomCategory",
  async (values, { rejectWithValue }) => {
    const {
      id,
      name,
      description,
      configuration,
      // eslint-disable-next-line no-unused-vars
      logo_data,
      asset_properties,
    } = values;

    const requestBody = {
      transaction_category: {
        name,
        ...(description ? { description } : {}),
        ...(configuration
          ? { configuration: { data: configuration } }
          : { configuration: {} }),
        ...(asset_properties ? { asset_properties: asset_properties } : {}),

        // ...(logo_data && Object.keys(logo_data).length ? { logo_data } : {}), /*commented because, if in case in future there will be requriement*/
      },
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transaction_categories/${id}`,
        requestBody,
        config,
      );
      return response.data;
    } catch (error) {
      if (error?.response?.data?.errors) {
        const errorMessage =
          error?.response?.data?.errors?.configuration?.[0] ||
          error?.response?.data?.errors?.base?.[0];
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        return rejectWithValue(error?.response?.status);
      } else {
        return rejectWithValue(error);
      }
    }
  },
);

export const enableCategory = createAsyncThunk(
  "categoryEnable",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transaction_categories/${id}/enable`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const disableCategory = createAsyncThunk(
  "categoryDisable",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transaction_categories/${id}/disable`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

const customCategory = createSlice({
  name: "customCategory",
  initialState: {
    customCategoryData: null,
    customCategoryLoading: null,
    customCategoryError: null,
    editCustomCategoryData: null,
    editCustomCategoryLoading: null,
    editCustomCategoryError: null,
    isCategoryEnableLoading: false,
    isCategoryDisableLoading: false,
    enableError: null,
    disableError: null,
    enableResponse: null,
    disableResponse: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCustomCategory.pending, (state) => {
        state.customCategoryLoading = true;
      })
      .addCase(createCustomCategory.fulfilled, (state, action) => {
        state.customCategoryLoading = false;
        state.customCategoryData = action.payload;
      })
      .addCase(createCustomCategory.rejected, (state, action) => {
        state.customCategoryLoading = false;
        state.customCategoryError = action.payload;
        state.customCategoryData = null;
      });

    builder
      .addCase(editCustomCategory.pending, (state) => {
        state.editCustomCategoryLoading = true;
      })
      .addCase(editCustomCategory.fulfilled, (state, action) => {
        state.editCustomCategoryLoading = false;
        state.editCustomCategoryData = action.payload;
      })
      .addCase(editCustomCategory.rejected, (state, action) => {
        state.editCustomCategoryLoading = false;
        state.editCustomCategoryError = action.payload;
        state.editCustomCategoryData = null;
      });

    builder.addCase(enableCategory.pending, (state) => {
      state.isCategoryEnableLoading = true;
    });
    builder.addCase(enableCategory.fulfilled, (state, action) => {
      state.isCategoryEnableLoading = false;
    });
    builder.addCase(enableCategory.rejected, (state, action) => {
      state.isCategoryEnableLoading = false;
    });

    builder.addCase(disableCategory.pending, (state) => {
      state.isCategoryDisableLoading = true;
    });
    builder.addCase(disableCategory.fulfilled, (state, action) => {
      state.isCategoryDisableLoading = false;
    });
    builder.addCase(disableCategory.rejected, (state, action) => {
      state.isCategoryDisableLoading = false;
    });
  },
});

export default customCategory.reducer;
